import { render } from "./subPostShow.vue?vue&type=template&id=0d54ebc6&scoped=true"
import script from "./subPostShow.vue?vue&type=script&lang=js"
export * from "./subPostShow.vue?vue&type=script&lang=js"

import "./subPostShow.vue?vue&type=style&index=0&id=0d54ebc6&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0d54ebc6"

export default script